import { render, staticRenderFns } from "./gasRates.vue?vue&type=template&id=61b07527"
import script from "./gasRates.vue?vue&type=script&lang=js"
export * from "./gasRates.vue?vue&type=script&lang=js"
import style0 from "./gasRates.vue?vue&type=style&index=0&id=61b07527&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports